export default __webpack_public_path__ + "283cad3.png";